import isAdmin from 'utils/isAdmin'

export default function isUserAdmin({ props, path }) {
  return isAdmin(props.user.group) ? path.true() : path.false()
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/isUserAdmin.js